module.exports = __webpack_public_path__ + "fdf7577439fa56892bc7a3451870c7ae.png";